import { render, staticRenderFns } from "./SaitenInput.vue?vue&type=template&id=5516f3ac&scoped=true&"
import script from "./SaitenInput.vue?vue&type=script&lang=ts&"
export * from "./SaitenInput.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenInput.vue?vue&type=style&index=0&id=5516f3ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5516f3ac",
  null
  
)

export default component.exports